export default "<div id=\"surveyContainer\"></div>\n<div id=\"surveyResult\"></div>";